import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/styles/storefront-polish.css";
import "@/styles/medeo-preview.css";
import "@/styles/performance.css";
import {applyFontPreview} from "@/lib/fontPreview";
import {enableManualScrollRestoration} from "@/lib/routeScroll";
import App from "@/App";
import { adoptServerContent } from "@/lib/ssrContent";
import { rememberMedia } from "@/lib/mediaMap";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Server copy of the page (edge-injected) stays visible until React has painted the same page.
// Direct CDN photo URLs used by the server copy: React renders the same URLs (no second download).
try { const el = document.getElementById("asans-media"); if (el) rememberMedia({media: JSON.parse(el.textContent)}); } catch {}
enableManualScrollRestoration();
applyFontPreview();
adoptServerContent();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
